
import SuperAgent from "superagent"
import { api_root } from '@src/index.js'
import { errorHandling, unauthorizedRedirect } from './error.handler.js'
import { getBearerAccessToken } from "./authenticate";

export function getUsersForOrganisation(organisation_id, callback, reject) {
  return SuperAgent
    .get(api_root + `/users/organisation/${organisation_id}`)
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch(reject)
}


export function getUsersForPartner(partner_id, callback, reject) {
  return SuperAgent
    .get(api_root + `/users/partner/${partner_id}`)
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch(reject)
}

export function getUser(id, callback, reject) {
  return SuperAgent
    .get(api_root + `/users/${id}`)
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch(reject)
}

export function getUserByEmail(email, callback, reject) {
  return SuperAgent
    .get(api_root + `/users/email/${email}`)
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch(reject)
}

export function getInternalUsers(callback, reject) {
  return SuperAgent
    .get(api_root + `/users/internal`)
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch(reject)
}


export function inviteUser(organisation_id, partner_id, first_name, last_name, locale, email, role, internal_user, callback, reject) {
  return SuperAgent
    .post(api_root + `/users/create`)
    .send({ organisation_id, partner_id, email, first_name, last_name, locale, role, internal_user })
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch((error) => {
      const errorMessage = (error.response && error.response.body && error.response.body.detail) || "An unknown error occurred";
      reject(errorMessage);
    })
    .catch(errorHandling)
}


export function setupMFA(email, callback, reject) {
  return SuperAgent
    .post(api_root + `/users/setup_mfa`)
    .send({ email })
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch(reject)
    .catch(errorHandling)
}


export function verifyMFA(email, mfa_code, device_name, callback, reject) {
  return SuperAgent
    .post(api_root + `/users/verify_mfa`)
    .send({ email, mfa_code, device_name })
    .withCredentials()
    .set('Authorization', getBearerAccessToken())
    .use(unauthorizedRedirect)
    .then((response) => {
      callback(response.body)
    })
    .catch((error) => {
      const status = error.response && error.response.status;

      if (status === 400) {
        // Client error - structured validation error with reason code
        const errorDetail = error.response && error.response.body && error.response.body.detail;
        const errorData = {
          type: 'client_error',
          status: 400,
          reason: errorDetail && errorDetail.reason,

        };
        reject(errorData);
      } else if (status === 422) {
        // Unprocessable entity - validation error
        const errorMessage = error.response && error.response.body && error.response.body.detail || "Request could not be processed due to validation errors.";
        const errorData = {
          type: 'client_error',
          status: 422,
          message: errorMessage
        };
        reject(errorData);
      } else if (status >= 500 || !status) {
        // Server error or unknown error
        const errorMessage = error.response && error.response.body && error.response.body.detail || "A server error occurred";
        const errorData = {
          type: 'server_error',
          status: status || 500,
          message: errorMessage
        };
        reject(errorData);
      } else {
        // Other errors (401, 403, etc.) - generic handling
        const errorMessage = error.response && error.response.body && error.response.body.message
          || error.message
          || "An error occurred";
        const errorData = {
          type: 'error',
          status: status,
          message: errorMessage
        };
        reject(errorData);
      }
    })
}
